import { AxiosInstance } from 'axios';
import { InterestDto } from './dto/interest.dto';
import { INTERESTS, INTERESTS_IMAGES, InterestsCategoryKeysEnum } from '../constants/intersets';
import { map } from 'lodash-es';
import { InterestsEnum, InterestsFilter, ListWithTotals } from '@sweatpals/shared';

export class InterestService {
	private readonly httpClient: AxiosInstance;

	constructor(httpClient: AxiosInstance) {
		this.httpClient = httpClient;
	}

	public async getPublicInterests(filter: InterestsFilter = {}): Promise<ListWithTotals<InterestDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<InterestDto>>('/interests/public/search', {
			params: filter,
		});

		return data;
	}

	public getInterestsFromAssets(): InterestDto[] {
		const keys = Object.keys(INTERESTS);

		return map(keys, (key: InterestsCategoryKeysEnum) => ({
			id: INTERESTS[key].id,
			name: INTERESTS[key].name,
			iconId: INTERESTS[key].id,
		}));
	}

	public getInterestIconById(id: InterestsEnum): string {
		let result = '';
		try {
			const icon = INTERESTS_IMAGES[id];
			result = icon?.image ?? '';
		} catch {
			result = '';
		}

		return result;
	}
}
